
import { defineComponent } from '@nuxtjs/composition-api'
import { getCountryCode } from '~/assets/ts/Locale'

export default defineComponent({
  props: {
    visibleDesktopNavigation: {
      type: String,
      required: true,
    },
    navData: {
      type: Object,
      required: true,
    },
    navActive: {
      type: Object,
      required: true,
    },
  },
  emits: ['hide-navigation'],
  setup(_props, { emit }) {
    const country = getCountryCode()
    const hideNavi = () => {
      emit('hide-navigation', '')
    }
    return { hideNavi, country }
  },
})
